import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";

export default class BaseBetPopupContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.checkBoxes = [];

        this.init();
        this.addListeners();
        this.addActions();
        this.hide();
    }

    init() {
        for(let i = 1; i <= 12; i++) {
            let checkBox = this.getChildByName('bet_' + i);
            checkBox.value = EntryPoint.GameModel.betPossible[i - 1];
            checkBox.checked = checkBox.value === EntryPoint.GameModel.bet;
            checkBox.enabled = !checkBox.checked;
            checkBox.actions = {
                checked: {
                    callback: this.onBetChecked, context: this, params: checkBox
                }
            };
            if (isNaN(checkBox.value)) {
                checkBox.visible = false;
            } else {
                this.checkBoxes.push(checkBox);
            }
        }
    }

    addListeners() {
        GlobalDispatcher.add('betPanel:switchPopup', this.switch, this);
        //GlobalDispatcher.add('model:betChanged', this.onBetChanged, this);
    }

    addActions() {

    }

    onBetChecked(data) {
        GlobalDispatcher.dispatch('ui:changeBet', data.id - 1);
        this.setChecked();
    }

    /*onBetChanged(event) {
        this.setChecked();
    }*/

    setChecked() {
        this.checkBoxes.forEach((checkBox, index)=> {
            checkBox.checked = checkBox.value === EntryPoint.GameModel.bet;
            checkBox.enabled = !checkBox.checked;
        });
    }


    switch() {
        if(this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    show() {
        this.setChecked();
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }
}